import { AutoMap } from "@automapper/classes";
import { EInterventionStatus } from "src/app/domain/enums/intervention-status";
import { EndoscopeDTO } from "./endoscope.dto";
import { GenerateurDTO } from "./generateur.dto";
import { UserDTO } from "./user.dto";
import { ZoneDTO } from "./zone.dto";
import { AppareilDTO } from "./appareil.dto";

export class InterventionDTO {

    /** ID SERVER */
    @AutoMap()
    code!: string;
    @AutoMap()
    nomChantier!: string
    @AutoMap()
    status!: EInterventionStatus;
    @AutoMap()
    isLastMinute: boolean = false;
    @AutoMap()
    adresseChantier?: string;
    @AutoMap()
    plannedDate!: string;

    @AutoMap()
    sampler: UserDTO = new UserDTO();

    // @AutoMap()
    // biocollecteur: AppareilDTO = new AppareilDTO()
    // @AutoMap()
    // applicateurContact: AppareilDTO = new AppareilDTO()
    // @AutoMap()
    // compteur: AppareilDTO = new AppareilDTO()
    // @AutoMap()
    // multimetre: AppareilDTO = new AppareilDTO()

    @AutoMap(() => [ZoneDTO])
    zoneList: ZoneDTO[] = [];

    @AutoMap(() => [GenerateurDTO])
    generateurDialyseList: GenerateurDTO[] = [];

    @AutoMap(() => [EndoscopeDTO])
    endoscopeList: EndoscopeDTO[] = [];
}